import { Identificacion } from "./identificacion";
import { Colonia } from "./colonia";
import { Direccion } from "./direccion";
import { GuiaDTO } from "./guia";
import { CargaZE } from "./cargaze";

/**Un usuario de ZE tiene un conjunto de choferes, estos son los que realizan las entregas */
export interface ChoferZE {
    IdRegistro: number;

    /**Nombre del chofer */
    Nombre: string;

    /**Datos de identificación del chofer */
    Identificacion: Identificacion;

    /**Colonia de la dirección del chofer */
    IdColonia: number;
    Colonia: Colonia;

    /**Direccion del chofer */
    Direccion: Direccion;

    /**Id del vehiculo asignado al chofer, si es null el chofer no puede salir a viajes de entrega */
    IdVehiculoZE: number | null;

    /**Zonas extendidas asignadas al chofer */
    ZonasExtendidas: ChoferZonaExtendida[];

    DireccionCalle: string;

    DireccionNumExt: string;

    DireccionNumInt: string;

    NumeroLicencia:string;

    IdCpSatColonia: number | null;

    IdCpSatMunicipio: number | null;

    IdCpSatLocalidad: number | null;

}

export interface ChoferZEDto extends ChoferZE {
    GuiasEnVehiculoAsignado: GuiaDTO[];

    NombreProveedor: string;
}

/**Mantiene la relación de las zonas extendidas asignadas a los choferes */
export interface ChoferZonaExtendida {
    IdRegistro: number;

    /**Id del chofer */
    IdChoferZE: number;

    /**Id del a zona extendida */
    IdZonaExtendida: number;
}

export interface ChoferZonaExtendidaDto extends ChoferZonaExtendida {
    NombreChoferZE: string
    NombreZonaExtendida: string
}

export interface ResumenChoferZE {
    IdChoferZE: number;
    NombreChofer: string;
    NombreVehiculo: string;
    Cargas: CargaZE[];
}


export interface ParametroResumenChofer {
    IdChoferZE: number;
    IdUserZE: number | null;
}

export enum TipoPersona {
    Fisica,
    Moral
}

export interface IdentificacionChoferZE {

    Ine: string;
    Rfc: string;
    Curp: string;
    Pasaporte: string;

    TipoPersona: TipoPersona | null;
}


// WEBPACK FOOTER //
// ./app/models/choferze.ts